import React, { useState, useContext } from "react";
import { Plus } from "lucide-react";
import { LanguageContext } from "../context/LanguageContext";
import { Section, SectionHeader } from "./ui/Section";

const FAQ = () => {
  const [expanded, setExpanded] = useState(null);
  const { faqTitle, faqDescription, faqCategories } = useContext(LanguageContext);

  return (
    <Section tone="light" id="faq">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeader eyebrow="FAQ" title={faqTitle} lead={faqDescription} size="md" className="lg:sticky lg:top-28" />
        </div>

        <div className="space-y-12 lg:col-span-8">
          {faqCategories.map((category, categoryIndex) => (
            <div key={categoryIndex}>
              <h3 className="mb-2 font-display text-sm font-semibold uppercase tracking-[0.18em] text-brand-teal">
                {category.category}
              </h3>
              <div className="divide-y divide-brand-line border-y border-brand-line">
                {category.questions.map((faq, questionIndex) => {
                  const key = categoryIndex * 100 + questionIndex;
                  const isExpanded = expanded === key;
                  return (
                    <div key={questionIndex}>
                      <button
                        type="button"
                        onClick={() => setExpanded(isExpanded ? null : key)}
                        className="flex w-full items-start justify-between gap-6 py-5 text-left"
                        aria-expanded={isExpanded}
                      >
                        <span className="text-base font-semibold text-brand-navy md:text-lg">{faq.question}</span>
                        <Plus
                          className={`mt-1 h-5 w-5 flex-shrink-0 text-brand-teal transition-transform duration-200 ${
                            isExpanded ? "rotate-45" : ""
                          }`}
                        />
                      </button>
                      <div
                        className={`overflow-hidden text-slate-600 transition-all duration-300 ease-in-out [&_a]:text-brand-teal [&_a]:underline ${
                          isExpanded ? "max-h-96 pb-5 opacity-100" : "max-h-0 opacity-0"
                        }`}
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default FAQ;
